import { http } from "api/http";

interface CreateFolder {
  name: string;
  clientId?: string;
  parent: string | null;
  type: "organization" | "client" | "task";
}

interface GetStorage {
  folderId: string | null;
  clientId: string;
  search?: string;
}

const getStorage = ({ queryKey }: any) => {
  const params: GetStorage = queryKey[1];
  return http.get("/storage", { params });
};

const getTotalStorage = ({ queryKey }: any) => {
  const clientId = queryKey[1];
  return http.get("/storage/total-storage", { params: { clientId } });
};

const searchStorage = (params: any) => {
  return http.get("/storage", { params });
};

const getStorageTree = ({ queryKey }: any) => {
  return http.get("/storage/tree", { params: { clientId: queryKey[1] } });
};

const getOrgStorage = () => {
  return http.get("/storage/org-total");
};

const createRequestDocument = (data: any) => {
  return http.post("/request-documents", data);
};

const updateRequestDocument = ({ id, data }: any) => {
  return http.put(`/request-documents/${id}`, data);
};

const deleteRequestDocument = ({ id }: any) => {
  return http.delete(`/request-documents/${id}`);
};

const getRequestDocuments = ({ queryKey }) => {
  const [, params] = queryKey;
  return http.get("/request-documents", { params });
};

export {
  getStorage,
  getStorageTree,
  searchStorage,
  getTotalStorage,
  getOrgStorage,
  createRequestDocument,
  updateRequestDocument,
  deleteRequestDocument,
  getRequestDocuments,
};
